import AppGridContainer from "@crema/core/AppGridContainer";
import { Box, Button, FormHelperText, Grid, TextField } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
    createPolicyManualsItem,
    updatePolicyManualsItem,
} from "redux/actions/Policies";
import { useParams } from "react-router-dom";
import {
    SUPPORTED_FORMAT_DOCS,
    SUPPORTED_FORMAT_PDF,
} from "shared/constants/AppConst";
const validationSchema = yup
    .object()
    .shape({
        title: yup
            .string()
            .trim()
            .required("Please enter title")
            .min(2, "Title should be greater than 2 characters")
            .max(255, "Title should be less than 255 characters"),
        file: yup
            .mixed()
            .test("required", "Please select file", (file) => {
                if (file?.length > 0) return true;
                return false;
            })
            .test("format", "Please upload valid file", (file) => {
                if (file.length > 0) {
                    if (file && SUPPORTED_FORMAT_PDF.includes(file[0].type)) {
                        return true;
                    }
                    if (file && SUPPORTED_FORMAT_DOCS.includes(file[0].type)) {
                        return true;
                    }
                    return false;
                } else {
                    return true;
                }
            }),
    })
    .required();

const updateValidationSchema = validationSchema.shape({
    file: yup.mixed().test("format", "Please upload valid file", (file) => {
        if (file.length > 0) {
            if (file && SUPPORTED_FORMAT_PDF.includes(file[0].type)) {
                return true;
            }
            if (file && SUPPORTED_FORMAT_DOCS.includes(file[0].type)) {
                return true;
            }
            return false;
        } else {
            return true;
        }
    }),
});
export default function AddManualItem(props) {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { setOpen, action, editRow } = props;
    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        register,
        getValues,
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(
            action.edit === true ? updateValidationSchema : validationSchema
        ),
        defaultValues: {
            title: "",
        },
    });

    const onSubmit = (data) => {
        const formData = new FormData();
        formData.append("manualId", id);
        formData.append("title", data.title);
        formData.append("type", "MANUAL");
        formData.append(`file`, data.file[0]);

        if (action.add === true) {
            dispatch(createPolicyManualsItem(formData)).then((res) => {
                if (res.httpStatus === "OK") {
                    setOpen(false);
                }
            });
        } else if (action.edit === true) {
            dispatch(updatePolicyManualsItem(editRow.id, formData)).then((res) => {
                if (res.httpStatus === "OK") {
                    setOpen(false);
                }
            });
        }
    };

    React.useEffect(() => {
        if (action.edit === true) {
            const fields = ["title", "fileName", "fileUrl"];
            fields.forEach((field) => {
                setValue(field, editRow[field]);
            });
        }
    }, [action]);

    return (
        <Box>
            <form onSubmit={handleSubmit(onSubmit)}>
                <AppGridContainer spacing={4} sx={{ pt: 2 }}>
                    <Grid item xs={12}>
                        <Controller
                            control={control}
                            name="title"
                            render={({ field }) => (
                                <TextField
                                    type="text"
                                    fullWidth
                                    label="Title*"
                                    id="title"
                                    variant="outlined"
                                    {...field}
                                />
                            )}
                        />
                        <FormHelperText error={true}>
                            {errors?.title?.message}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            {...register("file")}
                            InputLabelProps={{ shrink: true }}
                            name="file"
                            type="file"
                            fullWidth
                            inputProps={{
                                accept: ".doc,.docx,.pdf",
                            }}
                            id="outlined-basic"
                            label="Upload File *"
                            variant="outlined"
                        />
                        <FormHelperText error={errors?.file?.message}>
                            {errors?.file?.message ? (
                                errors?.file?.message
                            ) : (
                                <a
                                    href={getValues("fileUrl")}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {getValues("fileName")}
                                </a>
                            )}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Button
                                color="primary"
                                variant="outlined"
                                sx={{
                                    mr: 2,
                                }}
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button variant="contained" type="submit">
                                Submit
                            </Button>
                        </Box>
                    </Grid>
                </AppGridContainer>
            </form>
        </Box>
    );
}

AddManualItem.propTypes = {
    setOpen: PropTypes.func.isRequired,
    action: PropTypes.func.isRequired,
    editRow: PropTypes.object.isRequired,
};
